import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import { getImageSrc } from "@web-monorepo/static-assets";
import { AppMetadata, ToolListItem } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/list/assets/logo.svg");

export const appMetadataList = (): AppMetadata => ({
  href: "list",
  title: t`Directions`,
  variant: "list",
  icon,
});

export type ListState = {
  list: ToolListItem[];
  title: string;
};

export const RECEIVE_LIST = createAction("RECEIVE_LIST");
